import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface RoundButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
}

export default function RoundButton(props: RoundButtonProps) {
  const { icon, className = '', type = 'button', ...rest } = props;

  return (
    <button
      className={twMerge(
        'w-fit p-2 flex rounded-full border border-pmw-separator-light dark:border-pmw-separator-dark bg-pmw-sb-2-secondary-light dark:bg-pmw-sb-2-secondary-dark cursor-pointer',
        className,
      )}
      type={type}
      {...rest}
    >
      {icon}
    </button>
  );
}
